/** @jsx jsx */
import { jsx } from '@emotion/core';

import { CircularProgress, Button as Btn } from '@material-ui/core';
import { ButtonProps as BtnProps } from '@material-ui/core/Button';

import styles from './styles';
export type ButtonProps<C extends React.ElementType = 'button'> = BtnProps<
  C,
  { component?: C }
> & {
  loading?: boolean;
};

const defaultProps = {
  loading: false,
  component: 'button',
};

function Button<C extends React.ElementType = 'button'>(props: ButtonProps<C>) {
  const withDefault = { ...defaultProps, ...props };
  const { className, loading, disabled, component, ...rest } = withDefault;

  return (
    <Btn
      color="primary"
      disabled={loading ? true : disabled}
      variant="contained"
      css={styles}
      className={className}
      component={component}
      {...rest}
    >
      {loading && <CircularProgress aria-label="progress" size={24} />}
      {!loading && props.children}
    </Btn>
  );
}

export default Button;
